// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Chat Popup Styles */
.chat-popup-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 380px;
  max-height: 500px;
  background-color: white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  z-index: 1050;
  transform-origin: bottom right;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Opening Animation */
.chat-popup-container.opening {
  animation: popupOpen 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes popupOpen {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Closing Animation */
.chat-popup-container.closing {
  animation: popupClose 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes popupClose {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}

/* Chat Header */
.chatbox-header {
  background-color: #0F4372;
  padding: 12px 16px;
  flex-shrink: 0;
}

.chatbox-header h5 {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.chatbox-header .btn-link {
  font-size: 1.8rem;
  text-decoration: none;
  color: white !important;
  transition: transform 0.2s ease;
}

.chatbox-header .btn-link:hover {
  transform: scale(1.1);
}

/* Chat Body */
.chatbox-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 16px;
  height: 320px;
  background-color: #f8f9fa;
  scroll-behavior: smooth;
}

.chatbox-body::-webkit-scrollbar {
  width: 4px;
}

.chatbox-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.chatbox-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.chatbox-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Message Containers */
.message-container {
  margin-bottom: 16px;
  animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-container.message-user {
  display: flex;
  justify-content: flex-end;
}

.message-container.message-other {
  display: flex;
  justify-content: flex-start;
}

/* Message Bubbles */
.message-bubble {
  display: flex;
  align-items: flex-start;
  max-width: 85%;
  gap: 8px;
}

.message-bubble.user {
  flex-direction: row-reverse;
}

.message-bubble.other {
  flex-direction: row;
}

/* Message Content */
.message-content {
  flex: 1 1;
  min-width: 0;
}

.message-text {
  background-color: #f1f1f1;
  padding: 10px 14px;
  border-radius: 16px;
  word-wrap: break-word;
  hyphens: auto;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.message-bubble.user .message-text {
  background-color: #0F4372;
  color: white;
}

.message-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding: 0 4px;
}

.message-bubble.user .message-meta {
  justify-content: flex-end;
}

.message-bubble.other .message-meta {
  justify-content: flex-start;
}

/* Avatar */
.avatar {
  width: 36px;
  height: 36px;
  font-size: 16px;
  flex-shrink: 0;
  background-color: #e9ecef;
  border: 2px solid #dee2e6;
}

/* Input Section */
.input-group {
  border-top: 1px solid #dee2e6;
  background-color: white;
  border-radius: 0 0 12px 12px;
  padding: 12px 16px;
  flex-shrink: 0;
}

.input-group input.form-control {
  border: 1px solid #dee2e6;
  border-radius: 20px 0 0 20px;
  padding: 10px 16px;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input-group input.form-control:focus {
  border-color: #0F4372;
  box-shadow: 0 0 0 0.2rem rgba(15, 67, 114, 0.1);
}

.input-group input.form-control::placeholder {
  color: #6c757d;
  font-style: italic;
}

.input-group-append .btn {
  border-radius: 0 20px 20px 0;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  background-color: #0F4372;
  border-color: #0F4372;
  transition: all 0.2s ease;
}

.input-group-append .btn:hover {
  background-color: #0d3a63;
  border-color: #0d3a63;
  transform: translateY(-1px);
}

/* Messenger Icon */
.messenger-icon-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #0F4372;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(15, 67, 114, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
}

.messenger-icon-container:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(15, 67, 114, 0.4);
}

.messenger-icon-container img {
  width: 32px;
  height: 32px;
  filter: brightness(0) invert(1);
}

/* Notification Dot */
.notification-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 14px;
  height: 14px;
  background-color: #dc3545;
  border-radius: 50%;
  border: 2px solid white;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Utility Classes */
.chat-size {
  font-size: 11px;
  opacity: 0.7;
}

.chat-close-button {
  font-size: 1.8rem !important;
  width: 2em;
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.chat-close-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .chat-popup-container {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    transform-origin: bottom center;
  }
  
  .chatbox-header {
    border-radius: 0;
    padding: 16px;
  }
  
  .chatbox-body {
    height: calc(100vh - 140px);
    padding: 12px;
  }
  
  .message-bubble {
    max-width: 90%;
  }
  
  .input-group {
    border-radius: 0;
    padding: 16px;
  }
  
  .messenger-icon-container {
    bottom: 16px;
    right: 16px;
    width: 56px;
    height: 56px;
  }
  
  .messenger-icon-container img {
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 480px) {
  .chat-popup-container {
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
  
  .chatbox-body {
    height: calc(100vh - 120px);
    padding: 8px;
  }
  
  .message-bubble {
    max-width: 95%;
  }
  
  .message-text {
    padding: 8px 12px;
    font-size: 14px;
  }
  
  .avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .input-group {
    padding: 12px;
  }
  
  .input-group input.form-control {
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  .messenger-icon-container {
    bottom: 12px;
    right: 12px;
    width: 50px;
    height: 50px;
  }
}

/* Landscape Mobile */
@media (max-width: 768px) and (orientation: landscape) {
  .chat-popup-container {
    right: 0;
    left: 20%;
    width: 80%;
    height: 100vh;
  }
  
  .chatbox-body {
    height: calc(100vh - 120px);
  }
}

/* Tablet Styles */
@media (min-width: 768px) and (max-width: 1024px) {
  .chat-popup-container {
    width: 350px;
    max-height: 480px;
    bottom: 16px;
    right: 16px;
  }
  
  .chatbox-body {
    height: 300px;
  }
}

/* High DPI Screens */
@media (min-resolution: 192dpi) {
  .message-text {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ChatPopup.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE,+DAA+D;AACjE;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE,gEAAgE;AAClE;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6CAA6C;EAC7C,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,OAAO;IACP,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;IACT,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,QAAQ;IACR,SAAS;IACT,UAAU;IACV,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,mCAAmC;IACnC,kCAAkC;EACpC;AACF","sourcesContent":["/* Base Chat Popup Styles */\n.chat-popup-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 380px;\n  max-height: 500px;\n  background-color: white;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  z-index: 1050;\n  transform-origin: bottom right;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Opening Animation */\n.chat-popup-container.opening {\n  animation: popupOpen 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes popupOpen {\n  0% {\n    opacity: 0;\n    transform: scale(0.8) translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Closing Animation */\n.chat-popup-container.closing {\n  animation: popupClose 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes popupClose {\n  0% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.8) translateY(20px);\n  }\n}\n\n/* Chat Header */\n.chatbox-header {\n  background-color: #0F4372;\n  padding: 12px 16px;\n  flex-shrink: 0;\n}\n\n.chatbox-header h5 {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.chatbox-header .btn-link {\n  font-size: 1.8rem;\n  text-decoration: none;\n  color: white !important;\n  transition: transform 0.2s ease;\n}\n\n.chatbox-header .btn-link:hover {\n  transform: scale(1.1);\n}\n\n/* Chat Body */\n.chatbox-body {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 16px;\n  height: 320px;\n  background-color: #f8f9fa;\n  scroll-behavior: smooth;\n}\n\n.chatbox-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.chatbox-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.chatbox-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 2px;\n}\n\n.chatbox-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Message Containers */\n.message-container {\n  margin-bottom: 16px;\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n@keyframes messageSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message-container.message-user {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.message-container.message-other {\n  display: flex;\n  justify-content: flex-start;\n}\n\n/* Message Bubbles */\n.message-bubble {\n  display: flex;\n  align-items: flex-start;\n  max-width: 85%;\n  gap: 8px;\n}\n\n.message-bubble.user {\n  flex-direction: row-reverse;\n}\n\n.message-bubble.other {\n  flex-direction: row;\n}\n\n/* Message Content */\n.message-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.message-text {\n  background-color: #f1f1f1;\n  padding: 10px 14px;\n  border-radius: 16px;\n  word-wrap: break-word;\n  hyphens: auto;\n  line-height: 1.4;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.message-bubble.user .message-text {\n  background-color: #0F4372;\n  color: white;\n}\n\n.message-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  padding: 0 4px;\n}\n\n.message-bubble.user .message-meta {\n  justify-content: flex-end;\n}\n\n.message-bubble.other .message-meta {\n  justify-content: flex-start;\n}\n\n/* Avatar */\n.avatar {\n  width: 36px;\n  height: 36px;\n  font-size: 16px;\n  flex-shrink: 0;\n  background-color: #e9ecef;\n  border: 2px solid #dee2e6;\n}\n\n/* Input Section */\n.input-group {\n  border-top: 1px solid #dee2e6;\n  background-color: white;\n  border-radius: 0 0 12px 12px;\n  padding: 12px 16px;\n  flex-shrink: 0;\n}\n\n.input-group input.form-control {\n  border: 1px solid #dee2e6;\n  border-radius: 20px 0 0 20px;\n  padding: 10px 16px;\n  font-size: 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input-group input.form-control:focus {\n  border-color: #0F4372;\n  box-shadow: 0 0 0 0.2rem rgba(15, 67, 114, 0.1);\n}\n\n.input-group input.form-control::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.input-group-append .btn {\n  border-radius: 0 20px 20px 0;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  background-color: #0F4372;\n  border-color: #0F4372;\n  transition: all 0.2s ease;\n}\n\n.input-group-append .btn:hover {\n  background-color: #0d3a63;\n  border-color: #0d3a63;\n  transform: translateY(-1px);\n}\n\n/* Messenger Icon */\n.messenger-icon-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  background-color: #0F4372;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(15, 67, 114, 0.3);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1000;\n}\n\n.messenger-icon-container:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 24px rgba(15, 67, 114, 0.4);\n}\n\n.messenger-icon-container img {\n  width: 32px;\n  height: 32px;\n  filter: brightness(0) invert(1);\n}\n\n/* Notification Dot */\n.notification-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 14px;\n  height: 14px;\n  background-color: #dc3545;\n  border-radius: 50%;\n  border: 2px solid white;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Utility Classes */\n.chat-size {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n.chat-close-button {\n  font-size: 1.8rem !important;\n  width: 2em;\n  height: 2em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.chat-close-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .chat-popup-container {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0;\n    transform-origin: bottom center;\n  }\n  \n  .chatbox-header {\n    border-radius: 0;\n    padding: 16px;\n  }\n  \n  .chatbox-body {\n    height: calc(100vh - 140px);\n    padding: 12px;\n  }\n  \n  .message-bubble {\n    max-width: 90%;\n  }\n  \n  .input-group {\n    border-radius: 0;\n    padding: 16px;\n  }\n  \n  .messenger-icon-container {\n    bottom: 16px;\n    right: 16px;\n    width: 56px;\n    height: 56px;\n  }\n  \n  .messenger-icon-container img {\n    width: 28px;\n    height: 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-popup-container {\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .chatbox-body {\n    height: calc(100vh - 120px);\n    padding: 8px;\n  }\n  \n  .message-bubble {\n    max-width: 95%;\n  }\n  \n  .message-text {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n  \n  .avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n  \n  .input-group {\n    padding: 12px;\n  }\n  \n  .input-group input.form-control {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  .messenger-icon-container {\n    bottom: 12px;\n    right: 12px;\n    width: 50px;\n    height: 50px;\n  }\n}\n\n/* Landscape Mobile */\n@media (max-width: 768px) and (orientation: landscape) {\n  .chat-popup-container {\n    right: 0;\n    left: 20%;\n    width: 80%;\n    height: 100vh;\n  }\n  \n  .chatbox-body {\n    height: calc(100vh - 120px);\n  }\n}\n\n/* Tablet Styles */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .chat-popup-container {\n    width: 350px;\n    max-height: 480px;\n    bottom: 16px;\n    right: 16px;\n  }\n  \n  .chatbox-body {\n    height: 300px;\n  }\n}\n\n/* High DPI Screens */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .message-text {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
